import { RefreshTokenRequestBody } from "@syla/shared/types/requests/RefreshTokenRequestBody";
import { AccessTokenResponse } from "@syla/shared/types/responses/AccessTokenResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export const refreshUrl = "/users/refresh";

export async function refreshAccessToken(
  body: RefreshTokenRequestBody,
): Promise<AccessTokenResponse> {
  try {
    const response = await axios.post<AccessTokenResponse>(refreshUrl, body);
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
